import { Component, Input } from '@angular/core';
import { UserService } from '../../../core/user.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-email-confirm-dialog',
  templateUrl: './email-confirm-dialog.component.html',
  styleUrls: ['./email-confirm-dialog.component.scss']
})
export class EmailConfirmDialogComponent {
  @Input() visible: boolean = false;
  mail: string;

  constructor(
    private userService: UserService,
    private messageService: MessageService,
    private translate: TranslateService
  ) { }

  public confirmMail(form) {
    if (!form.invalid) {
      this.userService.saveEmail(form.value.email)
        .subscribe(() =>  {
          this.visible = false;
          this.messageService.add({
            severity: "success",
            detail: this.translate.instant('admin-panel.save-email-success'),
            key: 'appMessage'
          });
        },
        error => {
          this.messageService.add({
            severity: "error",
            detail: this.translate.instant('admin-panel.save-email-failure'),
            key: 'appMessage'
          });
        });
    }
  }
}
